<template>
  <div class="grid col-12">
    <div class="col-2">
      <label for="tipoVia"
        >{{ $t("ctiaddress.field.typeOfRoad") }}{{ required ? "*" : "" }}</label
      >
      <div class="p-inputgroup">
        <Dropdown
          v-model="tipoVia"
          :options="tiposVia"
          optionLabel="valor"
          optionValue="clave"
          class="input"
          :disabled="disabled"
        ></Dropdown>
      </div>
    </div>
    <div class="col-10">
      <label for="direccion"
        >{{ $t("ctiaddress.field.address") }}{{ required ? "*" : "" }}</label
      >
      <div class="p-inputgroup">
        <InputText
          class="input"
          id="nifCifNie"
          type="text"
          v-model="direccion"
          :disabled="disabled"
        />
      </div>
    </div>
    <div class="col-12">
      <label for="pais"
        >{{ $t("ctiaddress.field.location") }}{{ required ? "*" : "" }}</label
      >
      <div class="p-inputgroup">
        <AutoComplete
          v-model="selectedPoblacion"
          :field="getLocalidad"
          :suggestions="filteredPoblacion"
          @complete="search"
          class="input"
          :disabled="disabled"
        >
          <template #option="slotProps">
            <div class="flex align-options-center">
              <div v-if="!searchCP">
                <b>{{ slotProps.option.localidad }}</b> ({{
                  slotProps.option.codigoPostal
                }}), {{ getProvincia(slotProps.option.claveProvincia) }}
              </div>
              <div v-if="searchCP">
                {{ slotProps.option.localidad
                }}<b>
                  ({{ slotProps.option.codigoPostal }}),
                  {{ getProvincia(slotProps.option.claveProvincia) }}</b
                >
              </div>
            </div>
          </template>
        </AutoComplete>
      </div>
    </div>
  </div>
</template>

<script>
import { LISTADO_TIPOS_VIA_DIRECCION } from "../../../graphQLQueries/ContactoQueries";
import { PROVINCIAS } from "../../../utils/constans";
import {
  AUTOCOMPLETE_POBLACION,
  DETALLE_PROVINCIA_POR_CP,
} from "@/graphQLQueries/ContactoQueries";

export default {
  name: "DireccionIcired",
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPoblacion: null,
      filteredPoblacion: [],
      tipoVia: "C",
      direccion: "",
      searchCP: false,
      tiposVia: [],
      validForm: {
        tipoVia: false,
        direccion: false,
        selectedPoblacion: false,
      },
    };
  },
  methods: {
    fetchTiposVia() {
        this.tiposVia=[];
        this.$apollo.query({
            query: LISTADO_TIPOS_VIA_DIRECCION,
            variables: {
                idioma: this.$i18n.locale,
            },
        }).then((suggestions) => {
            this.tiposVia = suggestions.data.listadoTiposViaDireccion;
        }).catch(() => {
            this.tiposVia = [];
        });
    },
    fetchLocalidad() {},
    search(event) {
      setTimeout(() => {
        this.searchCP = false;
        if (/^\d{1,5}$/.test(event.query)) {
          this.searchCP = true;
        }
        this.$apollo
          .query({
            query: AUTOCOMPLETE_POBLACION,
            variables: {
              prefix: event.query,
              idioma: this.$i18n.locale,
            },
          })
          .then((suggestions) => {
            console.log(suggestions);
            this.filteredPoblacion = suggestions.data.autocompletePoblacion;
          })
          .catch(() => {
            this.cardsCompanies = [];
          });
      }, 250);
    },
    getLocalidad(option) {
      return (
        option.localidad +
        ", " +
        option.codigoPostal +
        ", " +
        this.getProvincia(option.claveProvincia)
      );
    },
    getProvincia(claveProvincia) {
      return PROVINCIAS[claveProvincia];
    },
    setData(direccion) {
      this.tipoVia = direccion.tipoDireccion;
      this.direccion = direccion.direccion;
      if (direccion.codigoPostal !== "") {
        this.setPoblacion(direccion.codigoPostal);
      }
    },
    getData() {
        let data = {
            tipoDireccion: this.tipoVia,
            direccion: this.direccion,
            codigoPostal: "",
            localidad: "",
            provincia: "",
            pais: "",
          };
          if (this.selectedPoblacion) {
            data.codigoPostal = this.selectedPoblacion.codigoPostal;
            data.localidad = this.selectedPoblacion.localidad;
            data.provincia = this.selectedPoblacion.claveProvincia;
            data.pais = this.selectedPoblacion.codPais;
          }
          return data;
    },
    setPoblacion(codigoPostal) {
      this.$apollo
        .query({
          query: DETALLE_PROVINCIA_POR_CP,
          variables: {
            cp: codigoPostal,
            idioma: this.$i18n.locale,
          },
        })
        .then((suggestions) => {
          this.selectedPoblacion = suggestions.data.getDetallePoblacion;
        })
        .catch(() => {
          this.cardsCompanies = [];
        });
    },
    valid() {
      return this.validate();
    },
    validate() {
      if (this.required) {
        this.validForm.tipoVia = this.tipoVia !== "";
        this.validForm.direccion = this.direccion !== "";
        this.validForm.selectedPoblacion = this.selectedPoblacion !== null;
        return (
          this.direccion !== "" &&
          this.selectedPoblacion !== null &&
          this.tipoVia !== ""
        );
      }
      return true;
    },
  },
  mounted() {
    this.fetchTiposVia();
  },
};
</script>

<style scoped>
.row {
  display: flex;
  margin-bottom: 1rem;
}
.col {
  flex: 1;
  margin-right: 1rem;
}
.col-8 {
  flex: 8;
}
</style>
